export default (function (obj) {
  let keysToPick = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : [];
  return obj ? Object.keys(obj).filter(key => keysToPick.includes(key)).reduce((result, key) => {
    result[key] = obj[key];
    return result;
  }, {}) : obj;
});
//# sourceMappingURL=pickKeys.js.map